// GrindCTRL market persistence.
//
// Problem this solves: any link written as an absolute or root-relative URL
// ("https://sn2studios.co/collections/sn2" or "/pages/policies") drops the
// market subfolder, so a shopper browsing the Saudi Arabia storefront lands
// back on the primary (Egypt) market — prices flip from SAR to EGP mid-visit.
// Confirmed live on the announcement-bar "SHOP NOW" buttons and two menu
// links; those are merchant-entered URLs, so fixing them one by one only
// holds until the next banner is added. This fixes the whole class instead.
//
// Source of truth is Shopify's own server-rendered `Shopify.routes.root`
// ("/en-sa/" on the Saudi Arabia storefront, "/" on the primary market) —
// never location.pathname, which theme.liquid deliberately rewrites to the
// "/sa" vanity path. Reading routes.root also means this keeps working
// unchanged if another market is added later; nothing here is SA-specific.

(function () {
  var routes = (window.Shopify && window.Shopify.routes) || {};
  var root = routes.root || '/';
  if (root === '/') return; // primary market — nothing to prefix

  var prefix = root.replace(/\/+$/, ''); // "/en-sa"
  var VANITY = '/sa'; // address-bar alias the theme.liquid rewrite shows

  // Never prefix these. Admin, app proxy (the proxy signature is computed on
  // the path), CDN assets, Shopify-owned checkout/cart-permalink endpoints,
  // and well-known probes all break or 404 if a market subfolder is inserted.
  var SKIP_PATH = /^\/(admin|apps|cdn|checkout|checkouts|carts|tools|services|wpm|\.well-known|\d)/i;

  function alreadyInMarket(pathname) {
    return (
      pathname === prefix ||
      pathname.indexOf(prefix + '/') === 0 ||
      pathname === VANITY ||
      pathname.indexOf(VANITY + '/') === 0
    );
  }

  // Returns the corrected absolute URL, or null when the URL should be left
  // exactly as it is.
  function marketUrl(rawHref, base) {
    if (!rawHref) return null;
    if (/^(#|javascript:|mailto:|tel:|data:|blob:)/i.test(rawHref)) return null;

    var url;
    try {
      url = new URL(rawHref, base || window.location.href);
    } catch (e) {
      return null;
    }

    if (url.origin !== window.location.origin) return null; // external
    if (alreadyInMarket(url.pathname)) return null;
    if (SKIP_PATH.test(url.pathname)) return null;

    url.pathname = url.pathname === '/' ? prefix : prefix + url.pathname;
    return url.href;
  }

  // Rewriting the attribute (rather than only intercepting clicks) matters:
  // middle-click, ctrl-click, "open in new tab" and the browser's own status
  // bar all read the attribute directly and never fire a click handler.
  function fixAttributes(root_) {
    if (!root_ || root_.nodeType !== 1) return;

    var anchors = root_.querySelectorAll ? root_.querySelectorAll('a[href]') : [];
    for (var i = 0; i < anchors.length; i++) {
      var fixed = marketUrl(anchors[i].getAttribute('href'));
      if (fixed) anchors[i].setAttribute('href', fixed);
    }

    var forms = root_.querySelectorAll ? root_.querySelectorAll('form[action]') : [];
    for (var j = 0; j < forms.length; j++) {
      var fixedAction = marketUrl(forms[j].getAttribute('action'));
      if (fixedAction) forms[j].setAttribute('action', fixedAction);
    }

    // querySelectorAll skips the root element itself.
    if (root_.matches) {
      if (root_.matches('a[href]')) {
        var self = marketUrl(root_.getAttribute('href'));
        if (self) root_.setAttribute('href', self);
      } else if (root_.matches('form[action]')) {
        var selfAction = marketUrl(root_.getAttribute('action'));
        if (selfAction) root_.setAttribute('action', selfAction);
      }
    }
  }

  function run() {
    fixAttributes(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Backstop for anchors clicked before a pass has reached them (apps inject
  // markup at unpredictable times). Capture phase, so it runs before any
  // handler that might stop propagation.
  ['click', 'auxclick'].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        var anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
        if (!anchor) return;
        var fixed = marketUrl(anchor.getAttribute('href'));
        if (fixed) anchor.setAttribute('href', fixed);
      },
      true
    );
  });

  // Same for a form submitted before a pass reached it.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.nodeName !== 'FORM') return;
      var fixed = marketUrl(form.getAttribute('action'));
      if (fixed) form.setAttribute('action', fixed);
    },
    true
  );

  var queued = [];
  var scheduled = false;
  function flush() {
    scheduled = false;
    var batch = queued;
    queued = [];
    batch.forEach(fixAttributes);
  }
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type === 'attributes') {
        queued.push(m.target);
        return;
      }
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) queued.push(node);
      });
    });
    if (queued.length && !scheduled) {
      scheduled = true;
      requestAnimationFrame(flush);
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href', 'action'],
  });
})();
